import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import classNames from "classnames";

export const INDSymbolIcon = ({
  size,
  type,
  className = "",
  onClick,
  refHandler,
  id,
  dataId,
}: ISVGIconProps) => {
  return (
    <svg
      className={classNames("svg-icon", {
        [`svg-icon__size-${size}`]: size,
        [`svg-icon__type-${type}`]: type,
        [className]: className,
      })}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      ref={refHandler}
      id={id}
      data-id={dataId ? `${dataId}-svg-icon` : ""}
    >
      <path
        d="M7 3.73684C7 3.32989 7.3134 3 7.7 3H13.3C13.6866 3 14 3.32989 14 3.73684C14 4.14378 13.6866 4.47368 13.3 4.47368H12.0696C12.2141 4.701 12.3327 4.94818 12.4208 5.21052H13.3C13.6866 5.21052 14 5.54041 14 5.94736C14 6.3543 13.6866 6.68419 13.3 6.68419H12.5808C12.4067 8.34206 11.0714 9.63155 9.45 9.63155H9.04446L13.1735 15.8405C13.3952 16.1739 13.3181 16.6334 13.0014 16.8667C12.6847 17.1001 12.2482 17.019 12.0265 16.6856L7.12654 9.31726C6.97686 9.09218 6.95858 8.79813 7.07912 8.55443C7.19966 8.31073 7.43899 8.15787 7.7 8.15787H9.45C10.2966 8.15787 11.0029 7.52502 11.165 6.68419H7.7C7.3134 6.68419 7 6.3543 7 5.94736C7 5.54041 7.3134 5.21052 7.7 5.21052H10.8501C10.5309 4.76309 10.0225 4.47368 9.45 4.47368H7.7L7.69548 4.47366C7.31096 4.4711 7 4.14219 7 3.73684Z"
        fill="#888888"/>
    </svg>
  );
};
